import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-range',
  templateUrl: './pdf-find-range.component.html',
  styleUrls: ['./pdf-find-range.component.css'],
})
export class PdfFindRangeComponent {}
